import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import ClickOutside from 'react-click-outside';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/user';
import { connect } from 'react-redux';
import Translate from '../layout/Translate';
import { browserHistory } from 'react-router';
import Login from '../popups/Login';

class Header extends Component {



	componentWillMount() {
		this.hosts = {
			ru: 'https://www.baikalnature.ru',
			en: 'https://www.baikalnature.com',
			fr: 'https://www.baikalnature.fr'
		};
	}


	componentDidUpdate() {

		if (this.props.user.fullRedirect) {
			window.location.href = this.props.user.redirectPath;
			this.props.userActions.completeRedirect();
		}
		if (this.props.user.mainRedirect) {
			window.location.href = this.hosts[this.props.user.lang];
			this.props.userActions.completeRedirect();
		}
	}



	logout() {
		this.props.userActions.logout()
	}

	toggleMenu() {
		this.props.userActions.toggleMenu()
	}
	toggleLangSelect() {
		//console.info('toggle');
		this.props.userActions.toggleLangSelect();
	}
	closeLangSelect() {
		//console.info('close');
		if (this.props.user.langSelectOpen) {
			this.props.userActions.toggleLangSelect();
		}
	}
	selectCurrency(currency) {
		this.props.userActions.selectCurrency(currency);
		this.props.userActions.toggleLangSelect();
	}
	toggleLogin() {
		this.props.userActions.toggleLogin();
	}
	checkRedirect(path, lang) {
		if (lang != this.props.user.lang) {
			this.props.userActions.checkRedirect(path, lang);
		}
	}

  render() {

  	const { user } = this.props;
	  let path = (this.nextProps && this.nextProps.path)?this.nextProps.path.location.pathname:'',
		  hosts = this.hosts;

    return (
		<div className={(this.props.fixed?' header_fixed':'') + (this.props.absolute?' header_absolute':'')}>
			<div className="header">
				{this.props.main &&
					<div className="header__logo"></div>
				}
				{!this.props.main &&
					<Link to="/" className="header__logo"></Link>
				}
				<div className="header__phone"><Translate slug="header__phone" /></div>
				<ul className={"header__menu main-menu " + ("main-menu_"+this.props.user.lang)}>
					<li className="main-menu__item main-menu__item_icons">
						<button
						className={'header__menu-button ' +  ((user.menuOpen)?'header__menu-button_active':'')} onClick={this.toggleMenu.bind(this)}><span className="header__menu-button_center" ></span></button>
					</li>
					<li className="main-menu__item main-menu__item_lang">
						<ClickOutside onClickOutside={this.closeLangSelect.bind(this)}>
							<div className={"lang-select " + (this.props.user.langSelectOpen?'lang-select_active':'')}>
								<div className="lang-select__values" onClick={this.toggleLangSelect.bind(this)}>
									<span className="lang-select__value">{this.props.user.lang}</span>
									<span className={"lang-select__value lang-select__value_" + this.props.user.currency.id}>{(this.props.user.currency.id=='RUR')?'i':this.props.user.currency.sign}</span>
									<div className={"lang-select__arrow " + (this.props.user.langSelectOpen?'lang-select__arrow_active':'')}></div>
								</div>
									<div className={"lang-select__lists " + (this.props.user.langSelectOpen?'lang-select__lists_active':'')}>
										<ul className="lang-select__list">
											<li className={"lang-select__item " + (this.props.user.lang=='ru'?'lang-select__item_active':'')} onClick={this.checkRedirect.bind(this, hosts['ru'] + user.path, 'ru')}>RU</li>
											<li className={"lang-select__item " + (this.props.user.lang=='en'?'lang-select__item_active':'')} onClick={this.checkRedirect.bind(this, hosts['en'] + user.path, 'en')}>EN</li>
											<li className={"lang-select__item " + (this.props.user.lang=='fr'?'lang-select__item_active':'')} onClick={this.checkRedirect.bind(this, hosts['fr'] + user.path, 'fr')}>FR</li>
										</ul>
										<ul className="lang-select__list">
											{this.props.user.currencyList.map((currency, i)=>
												<li className={"lang-select__item lang-select__item_" + currency.id + (this.props.user.currency.id==currency.id?' lang-select__item_active':'')}  onClick={this.selectCurrency.bind(this, currency)}>{(currency.id=='RUR')?'i':currency.sign}</li>
											)}
											</ul>
									</div>
							</div>
						</ClickOutside>
					</li>
					{false && !!user.email &&
						<li className="main-menu__item"><Link to="/account">{user.email}</Link></li>
					}
					{false && !!user.email &&
						<li className="main-menu__item" ><a onClick={this.logout.bind(this)}><Translate slug="header__logout" /></a></li>
					}
					{false && !user.email &&
						<li className="main-menu__item"><a onClick={this.toggleLogin.bind(this)}><Translate slug="header__login" /></a>
						</li>
					}
					<li className="main-menu__item main-menu__item_uppercase"><Link to="/about"><Translate slug="menu__about" /></Link></li>
					<li className="main-menu__item main-menu__item_uppercase"><Link to="/map"><Translate slug="header__map" /></Link></li>
					<li className="main-menu__item main-menu__item_uppercase"><Link to="/destinations"><Translate slug="header__tours" /></Link></li>
				</ul>
			</div>
		</div>
    );
  }
}



function mapStateToProps(state) {
	return {
		user : state.user
	};
}


function mapDispatchToProps(dispatch) {
	return {
		userActions: bindActionCreators(userActions, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/common/components/layout/Header.js